import React from 'react';
import {observer} from 'mobx-react';
import {IndexTable, Button} from 'components';
import MemberGroupIcon from 'img/settings/settings-departments@2x.png';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl'; 

const ConfigureButton = observer(({match, history, benefitDivision}) => {
  return (
    <Button onClick={() => history.push(`${match.url}/benefit_divisions/${benefitDivision.id}`)}>
      <FormattedMessage id='taxable_benefits.Configure Division' />
    </Button>
  );
});

const BenefitDivisionTable = observer(({match, history, benefitDivision}) => {
  if (!benefitDivision.benefitClasses.length) return null;

  return (
    <IndexTable 
      actions={<ConfigureButton {...{match, history, benefitDivision}}/>}  
      title={t('taxable_benefits.BENEFIT_DIVISION', {divisionName: benefitDivision.name})}>
      {benefitDivision.benefitClasses.map(benefitClass => 
        <IndexTable.Row 
          key={benefitClass.id}
          icon={MemberGroupIcon}
          title={benefitDivision.companyInsuranceCarrier.name}
          description={benefitClass.fullName}
          showRoute={`${match.url}/${benefitClass.id}/rates`}
        />
      )}
    </IndexTable>
  );
});

export default BenefitDivisionTable;
